import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAccentureComponent } from './simple-icons-accenture.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAccentureComponent ],
    exports:      [ SimpleIconsAccentureComponent ],
    bootstrap:    []
})
export class SimpleIconsAccentureModule {}
